import {
    IonImg,
  } from "@ionic/react";

  import loadingImage from '../../assets/images/11.png';
  interface Props {
    setGaitAnalysisCompleted: Function;
  }
  const GaitAnalysisCompletedModal: React.FC<Props> = ({ setGaitAnalysisCompleted }) => {
    return (
      <>
        <div className="gait-analysis-completed-wrapper">
            <div className="text-center">
           <IonImg src={loadingImage} alt="loader-icon" placeholder={undefined} />
           </div>
           <p >Gait Analysis Complete!</p>
        </div>
      </>
    );
  };
  
  export default GaitAnalysisCompletedModal;
  